import { render, staticRenderFns } from "./TimeTrading.vue?vue&type=template&id=45028a52&scoped=true"
import script from "./TimeTrading.vue?vue&type=script&lang=js"
export * from "./TimeTrading.vue?vue&type=script&lang=js"
import style0 from "./TimeTrading.vue?vue&type=style&index=0&id=45028a52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45028a52",
  null
  
)

export default component.exports